export default "__VITE_ASSET__DXsI2XCQ__"